import React, { Component } from "react";
import PropTypes from "prop-types";
import ListingItem from "../LisingItem";
import List from "@material-ui/core/List";

export default class CreditAppLoanDetails extends Component {
  render() {
    let loan = this.props.loan;

    return (
      <List>
        <ListingItem secondaryText={"Credit Type: " + loan.CreditType} />
        <ListingItem secondaryText={"Amount: " + loan.Amount.Amount} />
        <ListingItem
          secondaryText={"Payout Amount: " + loan.PayoutAmount.Amount}
        />
        <ListingItem secondaryText={"Init fee: " + loan.InitFee.Amount} />
        <ListingItem secondaryText={"Term: " + loan.Term} />
        <ListingItem
          secondaryText={"Issue Date: " + (loan.IssueDate ?? "Not issued")}
        />
        <ListingItem secondaryText={"Stage: " + loan.CreditStage} />
        <ListingItem secondaryText={"Is active: " + loan.Active} />
        <ListingItem
          secondaryText={"Has Autogiro Consent: " + loan.HasAutogiroConsent}
        />
        <ListingItem secondaryText={"Id: " + loan.IntId} />
        {loan.IssueDate && (
          <React.Fragment>
            <ListingItem
              secondaryText={"DueAndOverdue: " + loan.DueAndOverdue.Amount}
            />
            {loan.DueAndOverdueParts.map((part) => {
              return (
                // eslint-disable-next-line react/jsx-key
                <React.Fragment>
                  <strong>
                    <ListingItem secondaryText={part.Date} />
                  </strong>
                  {part.Allocation.Principal && (
                    <ListingItem
                      secondaryText={
                        "Principal: " + part.Allocation.Principal.Amount
                      }
                    />
                  )}
                  {part.Allocation.Interest && (
                    <ListingItem
                      secondaryText={
                        "Interest: " + part.Allocation.Interest.Amount
                      }
                    />
                  )}
                  {part.Allocation.IntermediationFee && (
                    <ListingItem
                      secondaryText={
                        "IntermediationFee: " +
                        part.Allocation.IntermediationFee.Amount
                      }
                    />
                  )}
                  {part.Allocation.ReminderFee && (
                    <ListingItem
                      secondaryText={
                        "ReminderFee: " + part.Allocation.ReminderFee.Amount
                      }
                    />
                  )}
                  {part.Allocation.PenaltyFee && (
                    <ListingItem
                      secondaryText={
                        "PenaltyFee: " + part.Allocation.PenaltyFee.Amount
                      }
                    />
                  )}
                  {part.Allocation.InvoiceFee && (
                    <ListingItem
                      secondaryText={
                        "InvoiceFee: " + part.Allocation.InvoiceFee.Amount
                      }
                    />
                  )}
                  <br />
                </React.Fragment>
              );
            })}
          </React.Fragment>
        )}
      </List>
    );
  }

  static propTypes = {
    loan: PropTypes.object,
  };
}
